import { createReducer, on } from '@ngrx/store';
import { EventActions } from '../actions';
import { EventModel } from 'src/app/models/event.model';
import { StateModel } from 'src/app/models/state.model';
import { MonthModel } from 'src/app/models/month.model';

export interface EventState {
  searchedEvent: string;
  filteredState: StateModel | null;
  filteredMonth: MonthModel | null;
  filteredEvents: EventModel[] | null;
}

const initialState: EventState = {
  searchedEvent: '',
  filteredState: null,
  filteredMonth: null,
  filteredEvents: null,
};

export const eventReducers = createReducer(
  initialState,
  on(EventActions.searchEvent, (state, { searchedEvent }) => {
    return {
      ...state,
      searchedEvent,
    };
  }),
  on(EventActions.filterEventsByState, (state, { filteredState }) => {
    return {
      ...state,
      filteredState,
    };
  }),
  on(EventActions.filterEventsByMonth, (month, { filteredMonth }) => {
    return {
      ...month,
      filteredMonth,
    };
  }),
  on(EventActions.setFilteredEvents, (state, { filteredEvents }) => {
    return {
      ...state,
      filteredEvents,
    };
  })
);
